import React from 'react';
import Image1 from '../../assets/images/hydrogen_value1.jpeg';
import Image2 from '../../assets/images/hydrogen_value2.jpeg';
import Image3 from '../../assets/images/hydrogen_value3.jpg';
import Image4 from '../../assets/images/hydrogen_value4.jpeg';
import ScrollSnapBox from '../ScrollSnapBox';


// Service Data
const services = [
  {
    id: 1,
    title: 'Duralyze Clean Energy',
    description: 'Compared to fossil fuel-based alternatives, green molecules offer significant reductions in greenhouse gas emissions, especially when produced through truly renewable energy sources.',
    image: Image1,
  },
  {
    id: 2,
    title: 'Duralyze Versatility',
    description: 'Green molecules can be transported and utilized in various sectors, offering flexibility in decarbonization strategies.',
    image: Image2,
  },
  {
    id: 3,
    title: 'Duralyze Energy Storage',
    description: 'Green molecules can store energy generated during times of high renewable energy production, allowing for later use when renewable energy is unavailable. This helps overcome the intermittent nature of solar and wind power.',
    image: Image3, 
  },
  {
    id: 4,
    title: 'Duralyze Existing Infrastructure',
    description: 'Green molecules like green ammonia and green methanol have the potential to work with existing infrastructure, minimizing the need for entirely new systems.',
    image: Image4,
  }
];

const ServicesSection = () => {

  return (
    <div className='bg-gray-100 pb-8'>
      <div className='pt-4 md:pt-6 lg:pt-10 mx-6 sm:mx-8 md:mx-10 lg:mx-32'>
        <h2 className="text-theme-blue font-medium mt-2 text-lg sm:text-xl md:text-2xl lg:text-3xl">Why Green Molecules</h2>
      </div>
      <ScrollSnapBox>
        {({ inView }) => (
          <div 
            className="transition-all duration-1000 ease-out text-center"
            style={{
              transform: `translateY(${inView ? '0' : '80px'})`,
              opacity: inView ? 1 : 0
            }}
          >
            <div className="py-6 sm:py-8 md:py-10 lg:py-18 mx-6 sm:mx-8 md:mx-10 lg:mx-32">
              {/* Title */}
              <div className="mb-10 sm:mb-16 md:mb-20">
                  <h2 className="text-center text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold">
                      The true value of <span className='text-theme-blue'>Green Molecules</span>
                  </h2>
              </div>

              {/* Service card */}
              <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-4 gap-6 sm:gap-12 md:gap-10 lg:gap-16">
                  {services.map((service) => (
                  <div
                      key={service.id}
                      className="relative bg-white overflow-hidden transition-all duration-300 hover:shadow-xl hover:scale-105"
                  >
                      {/* Image */}
                      <div className="relative h-64 sm:h-72 md:h-80 lg:h-96">
                      <img
                          src={service.image}
                          alt={service.title}
                          className="w-full h-full object-cover"
                      />
                      </div>

                      {/* Text content */}
                      <div className="p-6">
                          <h3 className="text-xl text-gray-800 font-bold mb-3">{service.title}</h3>
                          <p className="text-gray-600 mb-4 text-sm md:text-base lg:text-lg">{service.description}</p>
                      </div>
                  </div>
                  ))}
              </div>
            </div>
          </div>
        )}
      </ScrollSnapBox>
    </div>
  );
};

export default ServicesSection;